import styled from "styled-components";

import { info as navBarInfo } from "@components/Navigation/NavBar";

export const Root = styled.section`
  position: relative;
  min-height: calc(100vh - var(${navBarInfo.cssVarHeaderHeight}));
  width: 100%;
  padding-top: ${props => props.theme.spacing.spacing_32};
  padding-bottom: ${props => props.theme.spacing.spacing_40};
  overflow-x: clip;
  overflow-y: visible;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.spacing_48};

  ${props => props.theme.breakpointsV2.smallTablet} {
    padding-top: ${props => props.theme.spacing.spacing_48};
    padding-bottom: ${props => props.theme.spacing.spacing_64};
    justify-content: center;
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    padding-top: ${props => props.theme.spacing.spacing_64};
    padding-bottom: ${props => props.theme.spacing.spacing_80};
  }
`;
